<template>
  <div class="plugin-wrap detail_multi_part_text layout" v-if="config && Array.isArray(config.nodes)">
    <template v-for="(item, index) in config.nodes">
      <section class="c-toggler c-toggler--fourth" :key="index">
        <h2 class="heading-h4 c-toggler__title">{{item.title}}</h2>
        <div class="c-toggler__content m-product-details__description">
          <p v-html="htmlify(item.desc)"></p>
          <!-- <p class="text--no-margin">
            <a href="#activeIngredients" class="link-with-arrow">查看嗅觉说明的细节</a>
          </p> -->
        </div>
      </section>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProductDetailMultiPartText",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  methods: {
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    }
  }
}
</script>

<style lang="scss" scoped>
  .detail_multi_part_text {
    padding: .3125rem 1.0625rem 1.5625rem;
    .c-toggler {
      margin: 5rem 0 2rem 0;
      &:first-child {
        margin: 0 0 2rem 0;
      }
    }
  }
  @media screen and (min-width: 48em) {
    .detail_multi_part_text {
      padding: 1.875rem 7.375rem .9375rem;
    }
  }
  @media screen and (min-width: 64em) {
    .detail_multi_part_text {
      padding: 1.875rem 1.875rem .9375rem;
    }
  }
  @media screen and (min-width: 75em) {
    .detail_multi_part_text {
      padding: 3.125rem 0 0;
    }
  }
</style>